/* eslint-disable max-len */
import { StencilChecklistsParams } from './types';

export const formatCheckList = (
  checkList: Omit<StencilChecklistsParams, 'checked'>[] | null | undefined,
  selectedList: number[] | null | undefined,
) => (Array.isArray(checkList) ? checkList : []).map((item) => ({
  ...item,
  checked: (selectedList ?? []).includes(item.id),
}));

export const initialCheckList = (
  checklist: StencilChecklistsParams[] | null | undefined,
) => (Array.isArray(checklist) ? checklist : [])
  .filter((item) => item.checked)
  .map((item) => item.id);
